import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { WorkoutAthleteResult, WorkoutAthleteResultCreate } from 'types';
import { client } from 'utils/api-client';

export default function useSaveWorkoutAthleteResult(
  workoutId: string | undefined,
): UseMutationResult<AxiosResponse<WorkoutAthleteResult>, AxiosError, WorkoutAthleteResultCreate> {
  const queryClient = useQueryClient();
  return useMutation((input: WorkoutAthleteResultCreate) => client.post('workout-athlete-results/', input), {
    onSuccess: () => {
      queryClient.invalidateQueries(['workout-athlete-results', workoutId]);
    },
  });
}
